import { render } from "./ModalStart.vue?vue&type=template&id=7eb54424&scoped=true"
import script from "./ModalStart.vue?vue&type=script&lang=js"
export * from "./ModalStart.vue?vue&type=script&lang=js"

import "./ModalStart.vue?vue&type=style&index=0&id=7eb54424&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb54424"]])

export default __exports__